export const PageHero = ({ eyebrow, title, sub, children }) => (
  <section className="relative overflow-hidden bg-[#0B1B33] noise">
    <div className="absolute inset-0 grid-bg" />
    <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
      {eyebrow && <div className="eyebrow rise">{eyebrow}</div>}
      <h1 className="rise mt-3 max-w-4xl font-display text-5xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl" style={{ animationDelay: "80ms" }}>
        {title}
      </h1>
      {sub && <p className="rise mt-5 max-w-2xl text-base text-white/70 md:text-lg" style={{ animationDelay: "160ms" }}>{sub}</p>}
      {children}
    </div>
  </section>
);

export const Section = ({ children, className = "", tone = "light" }) => (
  <section className={`${tone === "white" ? "bg-white" : tone === "dark" ? "bg-[#0B1B33] text-white" : "bg-[#F4F6FA]"} ${className}`}>
    <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">{children}</div>
  </section>
);

export const SectionHead = ({ eyebrow, title, sub, dark }) => (
  <div className="mb-10 max-w-3xl">
    {eyebrow && <div className="eyebrow">{eyebrow}</div>}
    <h2 className={`mt-2 font-display text-3xl font-bold uppercase tracking-tight sm:text-4xl ${dark ? "text-white" : "text-[#0B1B33]"}`}>{title}</h2>
    {sub && <p className={`mt-3 text-base ${dark ? "text-white/65" : "text-[#475569]"}`}>{sub}</p>}
  </div>
);

export const Loader = ({ label = "Loading" }) => (
  <div className="flex items-center gap-3 p-10 text-sm text-[#475569]" data-testid="loader">
    <span className="h-2 w-2 rounded-full bg-[#E0A21B] pulse-dot" /> {label}…
  </div>
);
